/**
 * UserListContainer
 * --
 */
import React from 'react';
import UserListPresenter from './UserListPresenter';

const UserListContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <UserListPresenter />
    </>
  );
};

export default UserListContainer;
